// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import Dashboard from './Dashboard';

import { IRoute } from '../';

const dashboardRoutes: IRoute[] = [
    {
        crumbText: 'home',
        component: Dashboard,
        exact: true,
        path: '/',
    },
];

export default dashboardRoutes;
